import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { AuthService } from 'src/app/api/core/auth/auth.service';
import { BaseWalkthroughStepComponent } from '../base-walkthrough-step/base-walkthrough-step.component';

type SmsClass = 'low' | 'mid' | 'high';

@Component({
  selector: 'hub-indicator-walkthrough',
  templateUrl: './hub-indicator-walkthrough.component.html',
  styleUrls: ['./hub-indicator-walkthrough.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HubIndicatorWalkthroughComponent extends BaseWalkthroughStepComponent implements OnInit {
  public accountTitle: string = 'Your Store';
  public smsValue: number = 0;
  public smsClass: SmsClass = 'low';
  public smsSub: Subscription;

  constructor(public el: ElementRef, public authService: AuthService, public changeRef: ChangeDetectorRef) {
    super(el);
  }

  ngOnInit() {
    this.accountTitle = this.authService.Active_bump_screen.account;
    this.changeRef.detectChanges();

    this.smsSub = interval(200).subscribe(() => {
      if (this.smsValue >= 1.2) {
        this.smsClass = 'low';
        this.smsValue = 0;
      } else {
        this.smsValue = this.smsValue + 0.03;
        if (this.smsValue <= 0.33) {
          this.smsClass = 'low';
        } else if (this.smsValue <= 0.66) {
          this.smsClass = 'mid';
        } else {
          this.smsClass = 'high';
        }
      }

      this.changeRef.detectChanges();
    });
  }

  ngOnDestroy() {
    if (this.smsSub) this.smsSub.unsubscribe();
  }
}
